import { SearchOperators } from '../../enums'

export const matchBackOperator = (
    backOperator?: string,
): SearchOperators.GREATER_THAN | SearchOperators.LESS_THAN | null => {
    if (backOperator === '+') {
        return SearchOperators.GREATER_THAN
    }

    if (backOperator === '-') {
        return SearchOperators.LESS_THAN
    }

    return null // SearchOperators.EQUAL_TO
}

export const matchFrontOperator = (
    frontOperator?: string,
):
    | SearchOperators.EQUAL_TO
    | SearchOperators.GREATER_THAN
    | SearchOperators.LESS_THAN
    | SearchOperators.NOT_EQUAL_TO
    | null => {
    if (frontOperator === '>') {
        return SearchOperators.GREATER_THAN
    }

    if (frontOperator === '<') {
        return SearchOperators.LESS_THAN
    }

    if (frontOperator === '<>') {
        return SearchOperators.NOT_EQUAL_TO
    }

    return null // SearchOperators.EQUAL_TO
}
